import { request } from "./http";

export const salesNotesService = {
  list({ clientId } = {}) {
    const params = new URLSearchParams();
    if (clientId !== undefined && clientId !== null && String(clientId).trim() !== "") {
      params.set("clientId", String(clientId));
    }
    const qs = params.toString();
    return request(`/SalesNotes${qs ? `?${qs}` : ""}`);
  },

  getById(id) {
    return request(`/SalesNotes/${id}`);
  },

  create(payload) {
    return request("/SalesNotes", { method: "POST", body: payload });
  },

  update(id, payload) {
    return request(`/SalesNotes/${id}`, { method: "PUT", body: payload });
  },

  remove(id) {
    return request(`/SalesNotes/${id}`, { method: "DELETE" });
  },
};
